import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

// Firebase configuration from Flutter app
const firebaseConfig = {
  apiKey: "AIzaSyCnSynpX0FX0hfva00TbhT7e_dksJllTzo",
  authDomain: "wvgo-33e55.firebaseapp.com",
  databaseURL: "https://wvgo-33e55-default-rtdb.firebaseio.com",
  projectId: "wvgo-33e55",
  storageBucket: "wvgo-33e55.firebasestorage.app",
  messagingSenderId: "765259291198",
  appId: "1:765259291198:web:37daf362bde80d53428f6f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const database = getDatabase(app);

// Initialize Storage (for file attachments)
export const storage = getStorage(app);

export default app;
